module.exports = __webpack_public_path__ + "static/media/cennik_en.3135703d.pdf";